const enum LocalConstants {
  SportsOfferingBase = 'kambi-sports-offering',
}

export const sportsOfferingQueryKeys = {
  BetOffersByIds: (betOfferIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'bet-offers-by-ids',
    ...betOfferIds,
  ],

  EventGroupsFromRoot: [LocalConstants.SportsOfferingBase, 'groups', 'events-groups-from-root'],
  EventGroupHighlights: [LocalConstants.SportsOfferingBase, 'groups', 'highlight'],
  EventsForGroupId: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'events',
  ],
  EventsForSport: (sport: string) => [LocalConstants.SportsOfferingBase, 'sport', sport, 'events'],
  BetOffersByEvents: (eventIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'event',
    ...eventIds,
  ],
  UpcomingEventsForAllSports: [
    LocalConstants.SportsOfferingBase,
    'events',
    'upcoming',
    'all-sports',
  ],
  LiveEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'live', 'all-sports'],
  Group: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
  ],
  EventsForCompetition: (sport: string, region: string, competition: string) => [
    LocalConstants.SportsOfferingBase,
    'sport',
    sport,
    region,
    competition,
  ],
  BetOffersPrepackByEvents: (eventIds: number[]) => [
    LocalConstants.SportsOfferingBase,
    'event',
    'prepack',
    ...eventIds,
  ],
} as const
